import React from 'react';
import { UserAction } from '~config/toastNotification';
import { t } from '~i18n';
import NotificationsStore from '~store/Notifications';

interface useMapFileProps {
  setMapFile: React.Dispatch<React.SetStateAction<File | undefined>>;
  notificationsStore: NotificationsStore;
}

export const MAX_FILE_SIZE_IN_MB = 10;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_IN_MB * (1024 * 1024);

export const useMapFile = ({ setMapFile, notificationsStore }: useMapFileProps) => {
  const [isFileValid, setIsFileValid] = React.useState<boolean>(true);

  const handleFloorPlanChange = React.useCallback((file?: File) => {
    // reset isFileValid
    setIsFileValid(true);
    setMapFile(file);
  }, []);

  const onInvalid = ({ isSizeInvalid, isTypeInvalid }: { isSizeInvalid?: boolean; isTypeInvalid?: boolean } = {}) => {
    notificationsStore.addUserActionNotification({
      type: UserAction.SiteFloorCreate,
      notificationType: 'error',
      message: isSizeInvalid
        ? t('alerts.site.floor.file.validation.size', { maxFileSize: MAX_FILE_SIZE })
        : isTypeInvalid
          ? t('alerts.site.floor.file.validation.fileType')
          : t('alerts.site.floor.file.validation.file'),
    });
    setIsFileValid(false);
  };

  return {
    onInvalid,
    isFileValid,
    setIsFileValid,
    handleFloorPlanChange,
  };
};
